/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Container, Image, Row, Spinner } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useBetween } from "use-between";
import "./index.scss";
import PapaAndBarkley from "../../assets/images/dashboard/papa_and_barkley.jpg";
import LiftTickets from "../../assets/images/dashboard/LiftTickets.jpeg";
import Surplus from "../../assets/images/dashboard/Surplus.jpeg";
import Almora from "../../assets/images/dashboard/Almora.jpeg";
import BeardBros from "../../assets/images/dashboard/Beard-Bros.jpeg";
import HH from "../../assets/images/dashboard/HH.jpeg";
import Zombi from "../../assets/images/dashboard/Zombi.jpeg";
import Labs710 from "../../assets/images/dashboard/710Labs.png";
import PureBeauty from "../../assets/images/dashboard/purebeautybrand.png";
import YadaYada from "../../assets/images/dashboard/yadayadabrand.png";
import SpotLightProduct from "../../assets/images/dashboard/spotlight-product.png";
import { productCategories } from "./landingPageData";
import { LeftArrow, RightArrow } from "../../components/icons";
import { Link, useNavigate } from "react-router-dom";
import CartLayout from "../../layout/CartLayout";
import { useAuthApi, useCatalogApi } from "../useApi";
import { useEffect, useState } from "react";
import ItemImage from "../../assets/images/collection/product.png";
import { toTwoDecimals } from "../../plugins";
import AwareButton from "../../components/button";

const images = {
  "Papa & Barkley": PapaAndBarkley,
  "Heavy Hitters": HH,
  "Beard Brothers": BeardBros,
  Surplus: Surplus,
  Almora: Almora,
  "Lift Tickets": LiftTickets,
  "Yada Yada": YadaYada,
  "Pure Beauty": PureBeauty,
  "710 Labs": Labs710,
  ZOMBiXYZ: Zombi,
};

const productCats = [
  { id: "new-release", label: "New Releases" },
  { id: "limited-product", label: "Limited Supply" },
  { id: "fast-movers", label: "Fast Movers" },
];

const Landing = () => {
  const {
    updating,
    setUpdating,
    getBanners,
    getProductsByAvailability,
    getAllBrands,
    getSpotLightProduct,
  } = useBetween(useCatalogApi);
  const { logout, customer } = useBetween(useAuthApi);
  const navigate = useNavigate();
  const [homeBanners, setHomeBanners] = useState([]);
  const [productSpotLight, setProductSpotLight] = useState({
    imagePath: SpotLightProduct,
    title: "Fast Acting Gummies",
    description: `Fast-acting formulation encourages onset within 15 minutes. \nInfused with 99%+ pure THCA diamonds \nSour flavors made from real fruit concentrates`,
    contentLink: "#",
  });

  const [brandsWithBranch, setBrandsWithBranch] = useState([
    {
      name: "name",
      branch: "branch",
    },
  ]);

  const [groupedBrands, setGroupedBrands] = useState({});

  const [activeProductCat, setActiveProductCat] = useState(productCats[0].id);
  const [productByAvailability, setProductByAvailability] = useState([]);

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-prev slick-arrow" + (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
      type="button"
    >
      <LeftArrow width="24" height="24" />
    </button>
  );

  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <button
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
      type="button"
    >
      <RightArrow width="24" height="24" />
    </button>
  );

  const featureImagesSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  };

  const productCatSettings = {
    dots: false,
    speed: 500,
    slidesToShow: 8,
    infinite: false,
    arrows: false,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 6.3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4.5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3.5,
        },
      },
    ],
  };

  const brandSettings = {
    dots: false,
    speed: 500,
    slidesToShow: 6,
    infinite: false,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2.5,
          arrows: false,
        },
      },
    ],
  };

  const shopByCategory = (category) => {
    category
      ? navigate(`/collection/all?category=${category}`)
      : navigate("/collection/all");
  };

  useEffect(() => {
    setUpdating(true);
    getBanners()
      .then((response) => {
        if (response.type === "success" && response.banners.length > 0) {
          setHomeBanners(response.banners);
        }
        setUpdating(false);
      })
      .catch(() => console.log("error"));

    getAllBrands()
      .then((response) => {
        if (response.type === "success" && response.brands.length > 0) {
          let cleaned = response.brands
            .filter((item) => {
              // Item could be a string or an object
              if (typeof item === "string") return Boolean(item);

              // If it's an object, try to get the name
              const brandName = item.Name?.value || item.Name || item;
              const finalName =
                typeof brandName === "object" ? brandName.value : brandName;
              return Boolean(finalName);
            })
            .map((item, index) => {
              // Check if item is already a string (new API format)
              if (typeof item === "string") {
                return {
                  name: item,
                  branch: "All Brands", // Default branch when no branch info available
                };
              }

              // Handle object structure (old API format)
              let brandName = item.Name?.value || item.Name;
              if (typeof brandName === "object" && brandName?.value) {
                brandName = brandName.value;
              }

              let branch = item.Branch?.value || item.Branch;
              if (typeof branch === "object" && branch?.value) {
                branch = branch.value;
              }

              return {
                name:
                  typeof brandName === "string" ? brandName : String(brandName),
                branch: typeof branch === "string" ? branch : "All Brands",
              };
            });

          // Filter out 710 Labs if customer doesn't have 710:CustomerID
          if (!customer["710:CustomerID"] && !customer["710:Enabled"]) {
            cleaned = cleaned.filter((brand) => brand.name !== "710 Labs");
          }

          setBrandsWithBranch(cleaned);
        }
        setUpdating(false);
      })
      .catch(() => console.log("error"));

    getSpotLightProduct()
      .then((response) => {
        console.log("response", response);
        if (response.type === "success" && response.spotlight) {
          setProductSpotLight(response.spotlight);
        } else {
          setProductSpotLight({
            imagePath: SpotLightProduct,
            title: "Product Spotlight",
            description: `Fast-acting formulation encourages onset within 15 minutes. \nInfused with 99%+ pure THCA diamonds \nSour flavors made from real fruit concentrates`,
            contentLink: "#",
          });
        }
      })
      .catch((error) => console.log("error", error));
  }, []);

  useEffect(() => {
    setUpdating(true);
    getProductsByAvailability(activeProductCat)
      .then((res) => {
        setProductByAvailability(res.products);
      })
      .finally(() => {
        setUpdating(false);
      });
  }, [activeProductCat]);

  useEffect(() => {
    if (brandsWithBranch.length > 0) {
      const grouped = brandsWithBranch.reduce((acc, brand) => {
        if (!acc[brand.branch]) {
          acc[brand.branch] = [];
        }
        acc[brand.branch].push(brand);
        return acc;
      }, {});
      setGroupedBrands(grouped);
    }
  }, [brandsWithBranch]);

  return (
    <CartLayout>
      <div className="w-100 dashboard-container">
        {homeBanners.length > 0 && (
          <div className="featured-images-wrapper">
            <Container>
              <div>
                <Slider {...featureImagesSettings}>
                  {homeBanners.map((item, index) => (
                    <Link
                      to={`/collection/${encodeURIComponent(item.contentLink)}`}
                      key={item._id}
                    >
                      <Image
                        fluid
                        src={item.imagePath || homeBanners[index].imagePath}
                        alt={item._id}
                        style={{
                          cursor: "pointer",
                          marginRight: "10px",
                        }}
                      />
                    </Link>
                  ))}
                </Slider>
              </div>
            </Container>
          </div>
        )}

        <div className="product-categories-wrapper">
          <Container>
            <Row className="justify-content-center">
              <Col lg="10">
                <Slider className="product-categories" {...productCatSettings}>
                  {productCategories.map((productCat, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        shopByCategory(
                          productCat.value === "Shop All"
                            ? undefined
                            : productCat.value,
                        );
                      }}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <div className="mb-2">{productCat.icon}</div>
                      <div>{productCat.title}</div>
                    </li>
                  ))}
                </Slider>
              </Col>
            </Row>
          </Container>
        </div>
        {/* <div className='bundle-products '>
                    <Container>
                        <h5>Good things come in bundles</h5>
                        <Row>
                            <Col md={3} sm={6}>
                                <div className='bundle-product-block'>
                                    <div className='product-image'>
                                        <div className='product-tag'>
                                            Bundle deal
                                        </div>
                                        <Image
                                            src={BundleProduct}
                                            fluid
                                            alt='Almora 3.5g Flower Bundle'
                                        />
                                    </div>
                                    <div className='product-name'>
                                        Almora 3.5g Flower Bundle
                                    </div>
                                    <div className='offered-deal'>
                                        Buy 2 Cases, Get 1 Free
                                    </div>
                                    <div className='shop-link-btn'>
                                        <ShopIcon />
                                        Shop bundle
                                    </div>
                                </div>
                            </Col>
                            <Col md={3} sm={6}>
                                <div className='bundle-product-block'>
                                    <div className='product-image'>
                                        <Image
                                            src={BundleProduct}
                                            fluid
                                            alt='Almora 3.5g Flower Bundle'
                                        />
                                    </div>
                                    <div className='product-name'>
                                        Almora 3.5g Flower Bundle
                                    </div>
                                    <div className='offered-deal'>
                                        Buy 2 Cases, Get 1 Free
                                    </div>
                                    <div className='shop-link-btn'>
                                        <ShopIcon />
                                        Shop bundle
                                    </div>
                                </div>
                            </Col>
                            <Col md={3} sm={6}>
                                <div className='bundle-product-block'>
                                    <div className='product-image'>
                                        <Image
                                            src={BundleProduct}
                                            fluid
                                            alt='Almora 3.5g Flower Bundle'
                                        />
                                    </div>
                                    <div className='product-name'>
                                        Almora 3.5g Flower Bundle
                                    </div>
                                    <div className='offered-deal'>
                                        Buy 2 Cases, Get 1 Free
                                    </div>
                                    <div className='shop-link-btn'>
                                        <ShopIcon />
                                        Shop bundle
                                    </div>
                                </div>
                            </Col>
                            <Col md={3} sm={6}>
                                <div className='bundle-product-block'>
                                    <div className='product-image'>
                                        <Image
                                            src={BundleProduct}
                                            fluid
                                            alt='Almora 3.5g Flower Bundle'
                                        />
                                    </div>
                                    <div className='product-name'>
                                        Almora 3.5g Flower Bundle
                                    </div>
                                    <div className='offered-deal'>
                                        Buy 2 Cases, Get 1 Free
                                    </div>
                                    <div className='shop-link-btn'>
                                        <ShopIcon />
                                        Shop bundle
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div> */}
        <div className="new-release-products">
          <Container>
            <h5>
              {productCats.map((prodCat) => (
                <span
                  key={prodCat.id}
                  onClick={() => setActiveProductCat(prodCat.id)}
                  className={`${activeProductCat === prodCat.id ? "active" : ""
                    }`}
                >
                  {prodCat.label}
                </span>
              ))}
              <span className="last-child">
                <Link to={`/collection/all?availability=${activeProductCat}`}>
                  See all <RightArrow />
                </Link>
              </span>
            </h5>
            <Row>
              {productByAvailability.map((newReleaseItem) => (
                <Col key={newReleaseItem.id} xl={3} md={6}>
                  <Link
                    to={`/product/${newReleaseItem.InventoryID?.value}`}
                    className="new-item"
                  >
                    {newReleaseItem.Label?.value ? (
                      <span className="discount-badge">
                        {newReleaseItem.Label?.value}
                      </span>
                    ) : null}
                    <div className="new-product-image">
                      <div className="img-wrapper">
                        {newReleaseItem.Primaryproductimagefirstdisplayed
                          .value ? (
                          <Image
                            src={
                              newReleaseItem.Primaryproductimagefirstdisplayed
                                .value
                            }
                            alt="product"
                          />
                        ) : (
                          <Image src={ItemImage} alt="product" />
                        )}
                      </div>
                    </div>
                    <div className="new-item-wrapper">
                      <h6 className="cursor-pointer">
                        {`${newReleaseItem.Brand.value} | ${newReleaseItem.Buyermenuproductname.value}`}
                      </h6>
                      <label>
                        <span className="product-name">
                          {newReleaseItem.StrainDescription.value}
                        </span>
                        <span
                          className="green-tg"
                          data-phenotype={
                            newReleaseItem.Phenotype?.value ||
                            newReleaseItem.Phenotype
                          }
                        >
                          <span>
                            {" "}
                            {(
                              newReleaseItem.Phenotype?.value ||
                              newReleaseItem.Phenotype
                            )
                              ?.charAt(0)
                              ?.toUpperCase()}
                          </span>
                        </span>
                      </label>
                      <div className="product-price-info d-inline-flex">
                        <label className="price-per-unit">{`$${toTwoDecimals(
                          newReleaseItem.DefaultPrice.value,
                        )}`}</label>
                        <label className="offered-price-info">{`$${toTwoDecimals(
                          newReleaseItem.DefaultPrice.value *
                          newReleaseItem.Casesize.value,
                        )} / case (${newReleaseItem.Casesize.value
                          } units)`}</label>
                      </div>
                    </div>
                  </Link>
                </Col>
              ))}
              {productByAvailability.length <= 0 && (
                <div className="p-3 b-1">
                  <h6>Currently no products available !</h6>
                </div>
              )}
            </Row>
          </Container>
        </div>

        <div className="brands-wrapper">
          <Container>
            <div className="title-wrapper">
              <h3>Shop by brand</h3>
            </div>

            {/* Iterate over each branch */}
            {Object.keys(groupedBrands).length > 0 ? (
              Object.entries(groupedBrands).map(([branchName, brands]) => {
                // NOTE: 710 brand is currently hidden regardless of customer.
                // Ensure brand names are strings before filtering
                const safeBrands = brands.map((brand) => ({
                  ...brand,
                  name:
                    typeof brand.name === "string"
                      ? brand.name
                      : String(brand.name || "Unknown"),
                  branch:
                    typeof brand.branch === "string"
                      ? brand.branch
                      : String(brand.branch || "Unknown"),
                }));

                const filteredBrands = safeBrands;

                if (filteredBrands.length === 0) return null;

                return (
                  <div key={branchName}>
                    <h4>{branchName}</h4> {/* Subheading for branch */}
                    <Slider {...brandSettings} className="img-brand-slider">
                      {[...filteredBrands]
                        .sort((a, b) => {
                          const priority = ["Heavy Hitters", "Pure Beauty"];
                          const aPriority = priority.includes(a.name)
                            ? priority.indexOf(a.name)
                            : Infinity;
                          const bPriority = priority.includes(b.name)
                            ? priority.indexOf(b.name)
                            : Infinity;
                          return aPriority - bPriority;
                        })
                        .map((brand, index) => (
                          <div
                            className={`img-brand ${index === 0 ? "first-item" : ""} ${index === filteredBrands.length - 1 ? "last-item" : ""}`}
                            key={brand.name}
                          >
                            <Link
                              to={`/collection/all?brand=${encodeURIComponent(brand.name)}`}
                            >
                              <Image
                                src={images[brand.name] || ""}
                                alt={brand.name}
                              />
                            </Link>
                          </div>
                        ))}
                    </Slider>
                  </div>
                );
              })
            ) : (
              <p>No brands available</p>
            )}
          </Container>
        </div>

        {productSpotLight && (
          <div className="spotlight-product-wrapper">
            <Container>
              <Row className="justify-content-center">
                <Col md={10}>
                  <Row className="spotlight-product-block align-items-center">
                    <Col sm={7} className="text-end">
                      <div className="product-image">
                        <Image
                          fluid
                          src={productSpotLight.imagePath}
                          alt={productSpotLight.title}
                        />
                      </div>
                    </Col>
                    <Col sm={5}>
                      <div className="product-detail">
                        <div className="product-title">Product Spotlight</div>
                        <div className="product-name">
                          {productSpotLight.title}
                        </div>
                        <div className="product-desp">
                          {productSpotLight.description
                            ?.split("\n")
                            .map((line, index, array) => (
                              <span key={index}>
                                {line}
                                {index < array.length - 1 && <br />}
                              </span>
                            ))}
                        </div>
                        <div className="product-action">
                          <AwareButton
                            onClick={() => {
                              navigate(
                                `/collection/${encodeURIComponent(productSpotLight.contentLink)}`,
                              );
                            }}
                            className="btn btn-lg btn-bottom btn-outline"
                          >
                            Shop Now
                            <RightArrow />
                          </AwareButton>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </div>
      {updating ? (
        <div className="update-loading">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : null}
    </CartLayout>
  );
};

export default Landing;
